"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const react_hook_form_1 = require("react-hook-form");
const getValue = (checked, value, schema) => {
    if (schema.customValue) {
        return checked ? schema.customValue : " ";
    }
    else {
        return !value;
    }
};
const BooleanSchemaComponent = (props) => {
    var _a;
    const _b = (0, core_1.useField)(props, [core_1.requiredValidator]), { value } = _b, _c = _b.registerProps, { onChange } = _c, registerProps = __rest(_c, ["onChange"]), { fieldState } = _b;
    const formContext = (0, react_hook_form_1.useFormContext)();
    const handleOnChange = (event) => {
        var _a, _b;
        onChange(Object.assign(Object.assign({}, event), { target: Object.assign(Object.assign({}, event.target), { value: getValue(event.target.checked, value, props.schema) }) }));
        (_b = (_a = props.schema).autoSaveHandler) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    const useValue = props.schema.customValue
        ? value === props.schema.customValue
        : value;
    const checked = props.schema.invert ? !useValue : !!useValue;
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState, loading: props.schema.showSpinner &&
            (fieldState === null || fieldState === void 0 ? void 0 : fieldState.isDirty) &&
            ((_a = formContext === null || formContext === void 0 ? void 0 : formContext.formState) === null || _a === void 0 ? void 0 : _a.isSubmitting) },
        react_1.default.createElement(Form_1.default.Check, Object.assign({ type: props.schema.uiType !== "check" ? "switch" : "checkbox", className: (0, classnames_1.default)({
                "has-error": fieldState.invalid,
            }), checked: checked, onChange: handleOnChange }, registerProps))));
};
BooleanSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("BooleanDisplayComponent", (value, schema) => {
    const invertedValue = schema.invert ? !value : !!value;
    return invertedValue ? "はい" : "いいえ";
});
exports.default = BooleanSchemaComponent;
